export default __webpack_public_path__ + "static/media/token_sOHM-transparent.ab0b6614.png";